import React, { useEffect, useState, useRef } from "react";
import {
  FrameContainer,
  Label,
  LabelText,
  BlockOne,
  CardContainer,
} from "./HomeEngagement.styled";
import { Link } from "react-router-dom";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import backgroundimage from "../../assets/backgroundimage.png";
import gamificationDefault from "../../assets/svg/gamification-default.svg";
import { ReactComponent as UserIcon } from "../../assets/svg/user-icon.svg";
import { ALL_MY_SPACES } from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import { clientWellness } from "../../App";
import MySpaces from "../../components/MySpaces/MySpaces";
import { useHistory } from "react-router-dom";

const HomeEngagement = () => {
  const [rowsPerPage] = useState(10);
  const [myspaces, setMySpaces] = useState([]);
  const history = useHistory();
  const mySpacesRef = useRef(null);

  useEffect(() => {
    // Access the clientHeight of MySpaces using the ref
    if (mySpacesRef && mySpacesRef.current) {
      const mySpacesHeight = mySpacesRef.current.clientHeight;
      // Set the height of BlockOne to the height of MySpaces
      const blockOne = document.getElementById("blockOne");
      if (blockOne) {
        blockOne.style.height = `${mySpacesHeight}px`;
      }
    }
  }, [myspaces]);

  const [
    runQueryAllMySpaces,
    { loading: loadingMySpacesFirst, error: errorMySpacesFirst },
  ] = useLazyQuery(ALL_MY_SPACES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setMySpaces(data.allMySpaces.slice(0, 2));
    },
  });

  useEffect(() => {
    runQueryAllMySpaces({
      variables: {
        startDate: null,
        finishDate: null,
        searchBy: "",
      },
    });
  }, []);
  let goToDetail = (myspace) => {
    setTimeout(() => {
      history.push({ pathname: "/DetailSpace", state: { url: myspace.url } });
    }, 0);
  };

  return (
    <>
      <FrameContainer>
        <Label>
          <LabelText>
            <Link to="/MySpaces">
              Engagement
              <ArrowForward />
            </Link>
          </LabelText>
        </Label>
        {Array.isArray(myspaces) && myspaces.length > 0 ? (
          ""
        ) : (
          <div style={{ marginBottom: "1vw" }}></div>
        )}
        <CardContainer>
          <>
            <BlockOne>
              <img
                src={backgroundimage}
                alt="BackgroundImage"
                className="img"
              />
              <span className="usericon">
                <UserIcon />
                <div className="buttonlayout">
                  <a
                    href="https://web.yammer.com/main/feed"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button"
                  >
                    GO TO YAMMER
                  </a>
                </div>
              </span>
            </BlockOne>
            {myspaces.length > 0 && (
              <MySpaces
                loadingMySpacesFirst={loadingMySpacesFirst}
                errorMySpacesFirst={errorMySpacesFirst}
                myspaces={myspaces}
                rowsPerPage={rowsPerPage}
                goToDetail={goToDetail}
                isHomeView={true}
              />
            )}
            {myspaces.length < 3 && (
              <>
                {[...Array(Math.max(0, 2 - myspaces.length))].map(
                  (el, index) => (
                    <div className="engagement-default" key={el}>
                      <img
                        className="coach-home_img-default"
                        src={gamificationDefault}
                        alt="Default Coach"
                      />
                    </div>
                  )
                )}
              </>
            )}
          </>
        </CardContainer>
      </FrameContainer>
    </>
  );
};
export default HomeEngagement;
